module.exports = __webpack_public_path__ + "static/media/measurements-top.47eb5ba3.png";